import Step from '../../components/onboarding/step.vue';

export default {
    path:'/signup/:id',
    component: Step,
    meta: {
        requiresAuth: false,
        showProgress: true,
        hideHeaderButtons: true,
        hideFooter: true,
    },
}